<template>
  <!--<div class="h-dialogContainer">
    <form id='updateDev'>
      <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div>
            <div class="h-inputLit"><span class="h-red-code">* </span>服务名称:</div>
            <input
              name="devName"
              class="e-input"
              type="text"
            />
          </div>
        </div>
      </div>
      <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div>
            <div class="h-inputLit"><span class="h-red-code">* </span>{{this.$t('Topo.devSoftVersion')}}:</div>
            <ejs-dropdownlist
              name="devSoftVersion"
            ></ejs-dropdownlist>
          </div>
        </div>
      </div>

    </form>
    <div class="h-clear-rowMg"></div>
  </div>-->
  <ParseForm :formParams='formParams'  formId='dataBusiness' :opCode='opCode'  ref='bus'></ParseForm>

</template>

<script>
import ParseForm from '../../../../subscriberMicro/util/parseFormNew/ParseForm';


export default {
  name: 'EditTemplate',
  components: {
    ParseForm
  },
  props: [
    'formParams',
    'opCode'
  ],
  data() {
    return {
     /* formParams: '',
      opCode: 'edit'*/
    };
  },
  mounted() {

  },
  methods: {
    getDatas(){
      return this.$refs.bus.getDatas();
    },
    setData(_name, _data) {
      this.$refs.bus.setData(_name, _data);
    },
    validateResult() {
      return this.$refs.bus.validateResult();
    }
  },
  beforeUpdate(){
    this.$forceUpdate();
  }

};
</script>
